import {s} from './scripting.js';
import {lazy} from './lazy.js';
import {doc} from './documentation.js';

/**
 * Does a transform on a certain step within a beat
 * For example  beat(0, 32, swap, life()) does swap on the 0
* and life on every other one
*/
doc(
    "beat",
    {
        step: "The step within the beat at which this executes the ifCond condition",
        beat: "The total number of steps within which we determine if the step has occured",
        ifCond: "The condition that is executed when the step is reached",
        elseCond: "The condition that is executed otherwise"
    },
    "Conditions on a certain step within a beat. For example, beat(0,32,a,b) executes a on the 1st beat of every bar, and executes b on every other step");
export const beat = (step, beat=32, ifCond, elseCond) => {
    return (coords, speed, width, stepNumber, history, ratio) => {
        if (stepNumber % beat === step) {
            return lazy(ifCond, coords, speed, width, stepNumber, history, ratio);
        } else {
            if (elseCond) {
                return lazy(elseCond, coords, speed, width, stepNumber, history, ratio);
            } else {
                return coords;
            }
        }
    };
};
